import { render, staticRenderFns } from "./shequhuodong.vue?vue&type=template&id=4f248ae9&scoped=true&"
import script from "./shequhuodong.vue?vue&type=script&lang=js&"
export * from "./shequhuodong.vue?vue&type=script&lang=js&"
import style0 from "./shequhuodong.vue?vue&type=style&index=0&id=4f248ae9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f248ae9",
  null
  
)

export default component.exports